module.exports = __webpack_public_path__ + "static/media/SF-2-if-wrong.d979dc55.mp3";